import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiStar,FiArrowUpRight} = FiIcons;
const WA = 'https://wa.me/919876543210?text=Hi%20Aurelle!%20I%20would%20love%20to%20hear%20more%20about%20your%20collections.';

const data = [
  {quote: 'The fabric quality is unreal. I have worn the rose wrap dress to three events and every single time someone asks where it is from.',name: 'Ananya Sharma',city: 'Mumbai'},
  {quote: 'Ordered over WhatsApp,styled through chat and delivered in two days. The most personal shopping experience I have ever had.',name: 'Priya Nair',city: 'Bengaluru'},
  {quote: 'Every piece feels like it was made just for me. Aurelle is my first call whenever I need something for an occasion.',name: 'Sanya Kapoor',city: 'New Delhi'}
];

function Testimonials() {
  return (
    <section id="testimonials" className="bg-[#F7F2EA] py-24 md:py-32 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="eyebrow eyebrow-center mb-5" style={{color: '#1F3D2E'}}>Loved by our women</p>
          <h2 className="font-display text-[clamp(36px,5vw,64px)] leading-tight text-[#1F1B17] font-light">
            Words we <em className="italic text-[#1F3D2E]">live</em> by
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {data.map((t,i) => (
            <motion.figure key={t.name} initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true,amount: 0.2}} transition={{delay: i * 0.1,duration: 0.5}} className="bg-[#EDE4D3] p-10 flex flex-col">
              <div className="flex gap-1 text-[#B87333] mb-6">{[...Array(5)].map((_,s) => <SafeIcon key={s} icon={FiStar} className="fill-current text-sm" />)}</div>
              <blockquote className="flex-1 font-display text-xl italic leading-relaxed text-[#1F1B17]">"{t.quote}"</blockquote>
              <figcaption className="mt-8 pt-5 border-t border-[#DDD3BE]">
                <span className="block font-sans text-sm tracking-wide text-[#1F1B17]">{t.name}</span>
                <span className="font-sans text-[10px] tracking-[0.2em] uppercase text-[#7A6E62]">{t.city}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
        <div className="mt-14 text-center">
          <a href={WA} target="_blank" rel="noreferrer" className="btn-gold group">
            Chat with our stylists <SafeIcon icon={FiArrowUpRight} className="group-hover:translate-x-1 transition" />
          </a>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
